import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToolbarService {
  announcementElHeight: number = 0;
  stickyHeaderElHeight: number = 0;

  get totalElHeight(): number {
    return this.announcementElHeight + this.stickyHeaderElHeight;
  }

  constructor() { }
}
